import {cljjs, resolveGoogExport} from 'dgetz/tsclj'

function getCanonicalHttpHeaders (unusedOmId, ladderContextId, timeoutMs, noCsrf) {
    let {get_canonical_http_headers} = resolveGoogExport('ladder.util');
    return cljjs(get_canonical_http_headers(unusedOmId, ladderContextId, timeoutMs, noCsrf));
}

export function canonicalHeaders () {
    // todo (assoc :page-info (browser/analytics-page-info))
    let noCsrf = false; /* do NOT bypass CSRF prevention, i.e., yes we want it */
    let unusedOmId = 0; /* Om has a request-id notion, it's not used */
    let ladderContextId = 0; /* todo - init DD span context in TypeScript */
    let timeoutMs = 15000; /* optional, we used Om's default value */
    return getCanonicalHttpHeaders(unusedOmId, ladderContextId, timeoutMs, noCsrf);
}
